import type {
  DeleteV1ScenariosIdPathParams,
  DeleteV1ScenariosId204,
  DeleteV1ScenariosId404,
  DeleteV1ScenariosId422,
  DeleteV1ScenariosIdMutationResponse,
} from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const deleteV1ScenariosIdPathParamsSchema = z.object({
  id: z.number().nullable(),
}) as unknown as ToZod<DeleteV1ScenariosIdPathParams>

export type DeleteV1ScenariosIdPathParamsSchema = DeleteV1ScenariosIdPathParams

/**
 * @description Scenario deleted
 */
export const deleteV1ScenariosId204Schema = z.any() as unknown as ToZod<DeleteV1ScenariosId204>

export type DeleteV1ScenariosId204Schema = DeleteV1ScenariosId204

/**
 * @description Scenario not found
 */
export const deleteV1ScenariosId404Schema = z.object({
  message: z.string(),
}) as unknown as ToZod<DeleteV1ScenariosId404>

export type DeleteV1ScenariosId404Schema = DeleteV1ScenariosId404

/**
 * @description Invalid id error
 */
export const deleteV1ScenariosId422Schema = z.object({
  success: z.boolean(),
  error: z.object({
    issues: z.array(
      z.object({
        code: z.string(),
        path: z.array(z.union([z.string(), z.number()])),
        message: z.string().optional(),
      }),
    ),
    name: z.string(),
  }),
}) as unknown as ToZod<DeleteV1ScenariosId422>

export type DeleteV1ScenariosId422Schema = DeleteV1ScenariosId422

export const deleteV1ScenariosIdMutationResponseSchema = z.lazy(() => deleteV1ScenariosId204Schema) as unknown as ToZod<DeleteV1ScenariosIdMutationResponse>

export type DeleteV1ScenariosIdMutationResponseSchema = DeleteV1ScenariosIdMutationResponse